module.exports = __webpack_public_path__ + "img/assets.ed77e723.png";